<mobile-drawer
    [isDrawerOpen]="openAccountsDrawer"
    (onOutsideClick)="handleOutsideClick()"
>
    <div class="mt-4 mb-4">
        <div class="org-details-container" #organizationDropdown *ngIf="showOrgsDropdown">
            <div class="curr-org-text  pointer-events-none">
                CURRENT ORGANIZATION
            </div>
            <div class="curr-org-container d-flex justify-content-between align-items-center mt-1 mb-4 px-2" role="button"
                (click)="openOrganizationDrawer()" (keydown)="openOrganizationDrawer()" (keyup)="openOrganizationDrawer()">
                <div class="d-flex justify-content-start">
                    <img class="d-lg-none" src="/icons/dbc/building.svg" alt="building" />
                    <div class="pointer-events-none p-3" *ngIf="!isMasterOrgSelected">
                        {{ currentCompleteOrg.name }}
                    </div>
                    <div class="pointer-events-none p-3" *ngIf="isMasterOrgSelected">
                        {{ masterOrgReduced.name }}
                    </div>
                </div>
                <img class="d-md-down-none" src="/icons/dbc/caret-down.svg" alt="caret" />
                </div>
        </div>
        <div
            (click)="handleRoutingToDashBoard()"
            (keydown)="handleRoutingToDashBoard()"
            (keyup)="handleRoutingToDashBoard()"
        >
            <div class="go-to-cards-dashboard-cta mb-4 pointer-events-none">
                Go to Cards dashboard
            </div>
        </div>
        <div (click)="logout()" (keyup)="logout()" (keydown)="logout()">
            <div class="logout-cta pointer-events-none">Logout</div>
        </div>
    </div>
</mobile-drawer>

<div class="org-drawer-wrapper">
    <mobile-drawer
        [isDrawerOpen]="isOrganizationsDrawerOpen"
        (onOutsideClick)="isOrganizationsDrawerOpen = false"
    >
        <div class="switch-org-text pointer-events-none">
            SWITCH ORGANIZATIONS
        </div>
        <input
            #searchInput
            type="text"
            placeholder="Search for organization"
            class="search-box"
            (input)="getSearchName($event)"
        />

        <div
            *ngIf="hasAccessToMasterOrg() && showMasterOrgSection"
            class="pb-2"
        >
            <div class="switch-container">
                <span class="switch-org-text pointer-events-none"
                    >MASTER ORGANIZATION</span
                >
            </div>
            <div
                *ngIf="!isMasterOrgSelected"
                class="master-option d-flex justify-content-between"
                (click)="onMasterOrgClick()"
                (keydown)="onMasterOrgClick()"
                (keyup)="onMasterOrgClick()"
            >
                <span class="master-name text-truncate pointer-events-none">{{
                    masterOrgReduced.name
                }}</span>
                <span class="float-right master-role pointer-events-none">{{
                    masterOrgReduced.role
                }}</span>
            </div>
            <div
                *ngIf="isMasterOrgSelected"
                class="master-option text-primary d-flex justify-content-between"
                (click)="onMasterOrgClick()"
                (keydown)="onMasterOrgClick()"
                (keyup)="onMasterOrgClick()"
            >
                <span
                    class="master-name text-truncate pointer-events-none d-flex align-items-center gap-2"
                    >{{ masterOrgReduced.name }}
                    <img src="/icons/dbc/primary_check.svg" alt="check" />
                </span>
                <span class="float-right master-role pointer-events-none">{{
                    masterOrgReduced.role
                }}</span>
            </div>
        </div>

        <span
            class="switch-org-text pointer-events-none"
            *ngIf="filteredOrgList.length > 1"
            >YOUR ORGANIZATIONS</span
        >

        <options-component
            *ngIf="filteredOrgList"
            [maxWidth]="'-webkit-fill-available'"
            [value]="currentOrg"
            (valueChange)="onOrgChanged($event)"
            [maxHeight]="'300px'"
            [highlightSelectedValue]="false"
            [optionLabelField]="'name'"
            [optionsType]="2"
            [optionSecondaryLabelField]="'role'"
            [optionValueField]="'id'"
            [listItems]="filteredOrgList"
            [enableInfiniteScrolling]="true"
            (fetchMoreData)="getMoreData()"
            [isFetchingData]="fetchingOrganizationsOnScroll"
        ></options-component>
    </mobile-drawer>
</div>
